const styles = ({ BREAKPOINTS }) => ({
  container: {
    background: '#fff',
    width: 0,
    overflow: 'scroll',
    position: 'sticky',
    top: 0,
    transition: 'width 300ms ease-in-out',
    boxShadow: 'inset 0px 1px 2px 0px #e5e5e5'
  },
  inner: {
    /*display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',*/
    height: '100%',
    pointerEvents: 'none',
    minWidth: '500px'
  },
  open: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '500px',
      '& > div': {
        pointerEvents: 'auto'
      }
    }
  },
  title: {
    marginBottom: '30px'
  },
  discussion: {
    padding: '10px 20px 0'
  },
  spinner: {
    fontSize: '25px',
    marginTop: '10px'
  },
  conclusion: {
    background: '#ebf9fe',
    padding: '8px 10px'
  }
})

export default styles
